var $c1ce9d969bfa6909$exports = {};
/////////////////////////
// Elements
const $c1ce9d969bfa6909$var$form = document.querySelector(".form");
const $c1ce9d969bfa6909$var$inputText = document.querySelector(".input__text");
const $c1ce9d969bfa6909$var$listContainer = document.querySelector(".list__container");
const $c1ce9d969bfa6909$var$list = document.querySelector(".list__items");
let $c1ce9d969bfa6909$var$listItems = Array.from(document.querySelectorAll(".list__item"));
let $c1ce9d969bfa6909$var$newItems = [];
const $c1ce9d969bfa6909$var$btnRemove = document.querySelector(".remove__item");
const $c1ce9d969bfa6909$var$saveToLocalStorage = function() {
    localStorage.setItem("toDo", JSON.stringify($c1ce9d969bfa6909$var$newItems));
};
const $c1ce9d969bfa6909$var$getLocalStorage = function() {
    const storedItems = JSON.parse(localStorage.getItem("toDo"));
    if (!storedItems) return;
    $c1ce9d969bfa6909$var$newItems = storedItems;
    console.log($c1ce9d969bfa6909$var$newItems);
    $c1ce9d969bfa6909$var$newItems.forEach((obj)=>{
        console.log(obj);
        $c1ce9d969bfa6909$var$renderItem(obj);
    });
};
const $c1ce9d969bfa6909$var$generateMarkup = function(obj) {
    return `<li class="list__item">
  <div class="todo__info">
    <span class="item__text">${obj.activity}</span>
    <div class="priority ${obj.priority}">${obj.priority}</div>
  </div>
  <div class="item__options">
  
  <button class="remove__item">\xd7</button>

</div>
</li>`;
};
const $c1ce9d969bfa6909$var$renderItem = function(item) {
    const markup = $c1ce9d969bfa6909$var$generateMarkup(item);
    $c1ce9d969bfa6909$var$list.insertAdjacentHTML("afterbegin", markup);
    $c1ce9d969bfa6909$var$listItems = Array.from(document.querySelectorAll(".list__item"));
};
$c1ce9d969bfa6909$var$form.addEventListener("submit", function(e) {
    e.preventDefault();
    const data = Array.from(new FormData($c1ce9d969bfa6909$var$form));
    const obj = Object.fromEntries(data);
    $c1ce9d969bfa6909$var$inputText.value = "";
    $c1ce9d969bfa6909$var$newItems.push(obj);
    $c1ce9d969bfa6909$var$saveToLocalStorage();
    $c1ce9d969bfa6909$var$renderItem(obj);
});
$c1ce9d969bfa6909$var$listContainer.addEventListener("click", function(e) {
    const item = e.target.closest(".list__item");
    if (!item) return;
    item.classList.toggle("checked");
});
const $c1ce9d969bfa6909$var$removeItem = function(index, obj) {
    const localStorageArr = JSON.parse(localStorage.getItem("toDo"));
    console.log(localStorageArr);
    const localStorageIndex = localStorageArr.findIndex((item)=>JSON.stringify(item) === JSON.stringify(obj));
    localStorageArr.splice(localStorageIndex, 1);
    console.log(localStorageArr);
    localStorage.clear();
    localStorage.setItem("toDo", JSON.stringify(localStorageArr));
    $c1ce9d969bfa6909$var$listItems[index].remove();
    $c1ce9d969bfa6909$var$listItems.splice(index, 1);
};
$c1ce9d969bfa6909$var$listContainer.addEventListener("click", function(e) {
    const btn = e.target.closest(".remove__item");
    if (!btn) return;
    const item = e.target.closest(".list__item");
    const task = item.querySelector(".item__text");
    const obj = $c1ce9d969bfa6909$var$newItems.find((data)=>{
        return task.textContent === data.activity;
    });
    console.log("object:", obj);
    const index = Array.from($c1ce9d969bfa6909$var$list.children).findIndex((li)=>li.querySelector(".item__text").textContent === item.querySelector(".item__text").textContent);
    console.log(index);
    $c1ce9d969bfa6909$var$removeItem(index, obj);
});
$c1ce9d969bfa6909$var$getLocalStorage();


//# sourceMappingURL=index.a2a06f9e.js.map
